<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="select_container">
      <el-select v-model="value" placeholder="请选择" style="width: 200px">
        <el-option
          v-for="item in categoryOptions"
          :key="item.typeId"
          :label="item.typeName"
          :value="item.typeId">
        </el-option>
      </el-select>
      <el-input v-model="input" placeholder="商品名称" style="width: 200px"></el-input>
      <el-button type="primary" @click="searchQuery()">搜索</el-button>
      <el-button type="primary" style="float: right" @click="addFood()">新增商品</el-button>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        highlight-current-row
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          property="goodsName"
          label="商品名称">
        </el-table-column>
        <el-table-column
          property="typeName"
          label="分类">
        </el-table-column>
        <el-table-column
          label="库存">
          <template slot-scope="scope" >
            <span>{{scope.row.stock}}</span>
            <span v-if="scope.row.stock<='5'" style="color: red">库存不足</span>
          </template>
        </el-table-column>
        <el-table-column
          property="integral"
          label="积分">
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          property="createTime"
          label="上传时间">
        </el-table-column>
        <el-table-column label="审核状态">
          <template slot-scope="scope" >
            <span v-if="scope.row.sell=='0'">下架</span>
            <span v-if="scope.row.sell=='1'">上架</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.sell=='0' " @click="adopt(scope.$index, scope.row)" type="text" size="small">上架</el-button>
            <el-button v-if="scope.row.sell=='1' " @click="adoptno(scope.$index, scope.row)" type="text" size="small">下架</el-button>
            <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getGoodslist,getComclassification,getGoodslistSearch,getUpshelf,getWnshelf,getDelGoodslist } from "../api/api"
  export default {
    data () {
      return {
        value: '',
        input:'',
        options:[],
        selectTable: {},
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
        dialogVisible:false,
        categoryOptions: [],
        selectedCategory: [],
      }
    },
    components: {
      headTop,
    },
    methods:{
      //时间戳转换
      formatDate:function (value){
        let dateee = new Date(value.createTime).toJSON();
        return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getGoodslist()
      },
      getGoodslist(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        //获取商品理列表
        getGoodslist(params).then(res=>{
          this.tableData = res.pageInfo
          this.total = res.total
        }).catch(error=>{
          console.log(error);
        })
      },
      getComclassification(){
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        //获取商品分类列表
        getComclassification(params).then(res=>{
          this.categoryOptions= res.pageInfo
          let pageInfo = {
            typeName : '全部',
            typeId:''
          }
          this.categoryOptions.unshift(pageInfo)
        }).catch(error=>{
          console.log(error);
        })
      },
      searchQuery(){
        //  查询
        let params={
          pageNum:this.currentPage,
          pageSize:this.limit,
          typeId:this.value,
          goodsName:this.input
        };
        getGoodslistSearch(params).then(res=>{
          this.tableData = res.pageInfo
          this.total = res.total
        }).catch(error=>{
          console.log(error);
        })
      },
      addFood(){
        //新增
        this.$router.push({path: 'addGoods'});
      },
      handleEdit(index, row) {
        //编辑
        this.$router.push({
          path: 'modGoods',
          query:{
            goodsId:row.goodsId
          }
        });
      },
      adopt(index,row){
        this.$confirm('确认上架吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            goodsId:row.goodsId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            sell:1,
          };
          getUpshelf(params).then(res=>{
            this.getGoodslist()
            this.$message({
              type: 'success',
              message: '上架成功'
            });
          }).catch(error=>{
            console.log(error);
          })
        })
      },
      adoptno(index,row){
        this.$confirm('确认下架吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            goodsId:row.goodsId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            sell:0,
          };
          getWnshelf(params).then(res=>{
            this.getGoodslist()
            this.$message({
              type: 'success',
              message: '下架成功'
            });
          }).catch(error=>{
            console.log(error);
          })
        })
      },
      handleDelete(index, row){
        //删除
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            goodsId:row.goodsId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
          };
          getDelGoodslist(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.tableData.splice(index, 1);
            }else{
              throw new Error(res.message)
            }
          }).catch(error=>{
            this.$message({
              type: 'error',
              message: res.msg
            });
          })
        })
      },
    },
    activated(){
      this.getGoodslist()
      this.getComclassification()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
</style>



// WEBPACK FOOTER //
// src/page/management.vue